import { Button, HStack } from "@chakra-ui/react";
import { FaCheck, FaCopy } from "react-icons/fa";
import { CopyReportToClipboard } from "./Helpers/utils";

const ReportActionsBar = ({
  aiAnalysis,
  copied,
  getAdvancedReportInfo,
  isExporting,
  isRTL,
  reportApiResponse,
  reportData,
  selectedReport,
  setCopied,
  t,
  toast,
}) => (
  <HStack justify="flex-start" pt={2} borderTop="1px solid" borderColor="gray.200">
    <Button
      size="sm"
      variant="outline"
      colorScheme="green"
      isLoading={isExporting}
      loadingText={t("reports.exporting", "جاري التصدير...")}
      isDisabled={isExporting}
      onClick={() =>
        CopyReportToClipboard({
          getAdvancedReportInfo,
          aiAnalysis,
          isRTL,
          reportApiResponse,
          reportData,
          selectedReport,
          setCopied,
          toast,
          t,
        })
      }
      leftIcon={copied ? <FaCheck /> : <FaCopy />}
    >
      {copied ? t("reports.copied", "تم النسخ") : t("reports.copyReport", "نسخ التقرير")}
    </Button>
  </HStack>
);

export default ReportActionsBar;
